var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgMid = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 22,
    viewBox: "0 0 37 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.16833 3.5C2.39431 3.5 0.973684 4.94367 0.973684 6.70259V15.2974C0.973684 17.0563 2.39431 18.5 4.16833 18.5H32.8317C34.6057 18.5 36.0263 17.0563 36.0263 15.2974V6.70259C36.0263 4.94368 34.6057 3.5 32.8317 3.5H4.16833ZM0 6.70259C0 4.37174 1.87589 2.5 4.16833 2.5H32.8317C35.1241 2.5 37 4.37174 37 6.70259V15.2974C37 17.6283 35.1241 19.5 32.8317 19.5H4.16833C1.87589 19.5 0 17.6283 0 15.2974V6.70259Z",
    fill: "#005FAD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.3571 13.5812C25.8547 13.32 26.2645 12.9191 26.5358 12.4282C26.8174 11.9081 26.9592 11.3243 26.9475 10.7334C26.9598 10.1445 26.8179 9.56265 26.5358 9.04506C26.2665 8.55745 25.8577 8.16066 25.3615 7.90511C24.799 7.62323 24.1752 7.48452 23.5458 7.50137H21.0866V13.9935H23.5458C24.1746 14.0085 24.7972 13.8668 25.3571 13.5812ZM25.2421 11.4716C25.1541 11.7073 25.0176 11.9221 24.8415 12.1022C24.4459 12.4455 23.9307 12.62 23.4071 12.588H22.6618V8.87882H23.4071C23.9307 8.84682 24.4459 9.0213 24.8415 9.3646C25.0175 9.54482 25.1539 9.75962 25.2419 9.99531C25.33 10.231 25.3677 10.4824 25.3528 10.7334C25.3678 10.9845 25.3301 11.2359 25.2421 11.4716Z",
    fill: "#005FAD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.999 7.50141V13.9936H18.4238V7.50141H19.999Z",
    fill: "#005FAD"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3363 13.9935V7.54671L15.421 7.55318L13.6877 12.0439L11.9262 7.55318H10V14H11.5773V9.96048L12.9857 14H14.3593L15.759 9.96912V13.9935H17.3363Z",
    fill: "#005FAD"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMid);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/mid.0e692eb346736889528c3ceeab6f5678.svg";